export default __webpack_public_path__ + "static/media/animedium-splash.3bb0374f.png";